/** common */
export const VISIBLE = "visible";
export const HIDDEN = "hidden";
export const OVERRIDE = "pnr-override";
/** button classes */

export const BUTTON_LEFT_ICON_CLASS = "pnr-button--icon-left";
export const BUTTON_RIGHT_ICON_CLASS = "pnr-button--icon-right";
export const BUTTON_CENTER_ICON_CLASS = "pnr-button--icon-center";
export const BUTTON_LABEL_CLASS = "pnr-button--label";
export const BUTTON_BASE_CLASS = "pnr-base-button";
export const BUTTON_CHROMELESS_CLASS = "pnr-chromeless-button";
export const BUTTON_SIMPLE_CLASS = "pnr-simple-button";
/** DatePicker classes */

export const DATEPICKER_CALENDAR_BUTTON = "pnr-datepicker__calendar-button";
/** select classes when in calendar */

export const CALENDAR_WEEK_NAME_CELL = "pnr-week_name";
export const CALENDAR_WRAPPER = "pnr-calendar__wrapper";
export const CALENDAR_MONTH_WRAPPER_DROPDOWN = "pnr-calendar__nav-select--month";
export const CALENDAR_MONTH_DROPDOWN = "pnr-calendar__nav-select-field--month";
export const CALENDAR_YEAR_DROPDOWN = "pnr-calendar__nav-select--year";
export const CALENDAR_YEAR_LABEL_EMPTY = "pnr-calendar__nav-select--year-empty";
/** feedback classes */

export const ICON_CLASS = "pnr-feedback--icon";
export const MESSAGES_CLASS = "pnr-feedback--messages";
export const DISMISS_BUTTON_CLASS = "pnr-feedback--dismiss--button";
/** accordion classes */

export const ACCORDION_ITEM_CLASS = "pnr-accordion-item";
export const ACCORDION_ITEM_ICON_CLASS = "pnr-accordion-item--icon";
export const ACCORDION_ITEM_BODY_CLASS = "pnr-accordion-item--body";
export const ACCORDION_ITEM_TITLE_CLASS = "pnr-accordion-item--title";
export const ACCORDION_ITEM_TITLE_TEXT_CLASS = "pnr-accordion-item--title-text";
export const ACCORDION_ITEM_TITLE_SELECTED_CLASS = "pnr-accordion-item--title--selected";
/** checkbox classes */

export const CHECKBOX_LABEL_CLASS = "pnr-checkbox--label";
export const CHECKBOX_LABEL_TEXT_CLASS = "pnr-checkbox--label-text";
/** footer classes */

export const FOOTER_NAVIGATION_CLASS = "pnr-footer--navigation";
/** MenuButton classes */

export const MENU_ITEM = "pnr-menu-item";
export const MENU_ITEM_LABEL = "pnr-menu-item__label";
export const MENU_ITEM_ROW = "pnr-menu-item__row";
export const MENU_ITEM_BUTTON_LABEL = "pnr-button__label";
/** radio button classes */

export const RADIOBUTTON_LABEL_CLASS = "pnr-radio-button--label";
export const RADIOBUTTON_LABEL_ERROR_CLASS = "pnr-radio-button--error";
export const RADIOBUTTON_LABEL_TEXT_CLASS = "pnr-radio-button--label-text";
/** Table row number class */

export const TABLE_ROW_NUMBER_CLASS = "pnr-table__rownumber";
/** Table Class */

export const TABLE_ROW_CLASS_SELECTED = "pnr-table__row--selected";
/** Table Selectable class */

export const TABLE_SELECTABLE_CLASS = "pnr-table__selectable";
/** Container classes */

export const CONTAINER_CLICKABLE_CLASS = "pnr-container--clickable";
export const CONTAINER_CLICKABLE_HOVER_CLASS = "pnr-container--clickable-hover";
/** Section classes */

export const SECTION_HEADER_FOCUS_CLASS = "pnr-section__header--focus";
/** Toggleswitch classes */

export const TOGGLESWITCH_KNOB = "pnr-toggleswitch__knob";
export const TOGGLESWITCH_KNOB_CIRCLE = "pnr-toggleswitch__knob-circle";
/** MessageBar classes */

export const MESSAGEBAR_ICON_CLASS = "pnr-messagebar--icon";
/** Select classes */

export const SELECT_BACKGROUND_SCROLL_CLASS = "pnr-select__background-scroll";
/** Fieldset classes */

export const FIELDSET_LEGEND_WRAPPER = "pnr-fieldset__wrapper";
/** ThemeProvider classes */

export const THEMEPROVIDER_ROOT = "pnr-theme-provider";
export const THEMEPROVIDER_COMPATIBILITY = "pnr-mode--compatibility";